// Display formatting for phone numbers rendered in transaction views,
// receipt modals, ledger tabs, and dashboard cards, in the Hakikisha style
// (groups of three, right-aligned, space-separated). Never applied to a
// form input value: forms keep the raw digit string the user is typing.
//
// Rule: reverse the string, chunk by three characters, reverse each chunk,
// join with a space. Works on raw phones ("254712345678" becomes "254 712
// 345 678"), on the masked form the server returns ("254712***678" becomes
// "254 712 *** 678"), and on shorter formats. Non-digit runs like "***"
// are preserved position-for-position.
export const formatPhoneForDisplay = (value) => {
    if (value === null || value === undefined) return value;
    const raw = String(value).trim();
    if (raw === '') return value;
    // Preserve a leading "+" on E.164 numbers so the country code stays
    // contiguous with it: "+254741379714" becomes "+254 741 379 714" and
    // not "+ 254 741 379 714". Chunking only ever applies to the body.
    const hasPlus = raw.startsWith('+');
    const body = hasPlus ? raw.slice(1) : raw;
    const reversed = body.split('').reverse().join('');
    const chunks = reversed.match(/.{1,3}/g) ?? [];
    const formatted = chunks.map((chunk) => chunk.split('').reverse().join('')).reverse().join(' ');
    return hasPlus ? `+${formatted}` : formatted;
};

// Formats a `receiver_party` compound value ("phone - name") for display:
// the phone half is Hakikisha-formatted, the name half is left untouched.
// A single-token value with no separator is treated as a phone when it
// reads mostly numeric, and left alone otherwise (never mangling a name).
export const formatReceiverPartyForDisplay = (value) => {
    if (value === null || value === undefined) return value;
    const raw = String(value);
    if (raw.trim() === '') return value;
    if (raw.includes(' - ')) {
        const separatorIndex = raw.indexOf(' - ');
        const phone = raw.slice(0, separatorIndex);
        const name  = raw.slice(separatorIndex + 3);
        return `${formatPhoneForDisplay(phone)} - ${name}`;
    }
    const digitCount = raw.replace(/[^\d]/g, '').length;
    return digitCount >= raw.length * 0.7 ? formatPhoneForDisplay(raw) : raw;
};
